import Axios from '../../../networking/interceptor';
import { driver_identity_document } from '../../../networking/urlEndPoints';

export const getDriverDocument = (documentType, signal) => Axios.get(
    driver_identity_document(documentType),
    { responseType: 'blob', signal }
);
